import downloadjs from 'downloadjs'
import { fetchWithToken } from '@hublot-io/core-api/client'
import config from '../utils/apiUtils'

export const RecettesService = {
  getAllRecettes() {
    return fetchWithToken(`${config().hygieneService}/recettes`, { method: 'GET' })
      .then((response) => response.json())
      .catch((error) => ({ message: 'Requête invalide', err: error }))
  },
  download(data) {
    return fetchWithToken(`${config().pdfService}`, {
      method: 'POST',
      body: JSON.stringify({
        data,
        url: `${document.location.origin}/recette.html`,
      }),
    }).then((response) => response.blob())
      .then((file) => {
        downloadjs(file, `${data.title}.pdf`)
      })
  },
}
